export default {
  UNTRANSLATED_CUSTOM_CODE: 'untranslated_custom_code',
};
